exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#footer {\n    position: absolute;\n    bottom: 10px;\n    left: 0px;\n    width: 100%;\n    text-align: center;\n    color: #999;\n    line-height: 1.7em;\n    font-family: Helvetica, Arial, sans-serif;\n    font-size: 12px;\n}\n", ""]);

